// Typed fee / adjustment line items on order and harvest-report invoicing.
// Values are display strings — the API stores them as-is (FeeAdjustmentTypeEnum).
export const FEE_ADJUSTMENT_TYPES = [
  'Deposit',
  'Activation Fee',
  'Labor Fee',
  'Minimum Usage Fee',
  'Signage Fee',
  'Grants',
  'Credit Memos',
  'Other',
] as const;

export type FeeAdjustmentRow = {
  type: string;
  amount: number;
};

export const MAX_FEE_ADJUSTMENTS = 5;

export const sumFeeAdjustments = (rows?: FeeAdjustmentRow[]): number =>
  (rows || []).reduce((acc, r) => acc + (Number(r?.amount) || 0), 0);

/**
 * Initial editor rows for a record: its saved typed rows, or — for records
 * saved before fee types existed — the legacy scalar seeded as one "Other" row.
 */
export const toFeeRows = (
  feeAdjustments?: FeeAdjustmentRow[],
  legacyFeeAdjustment?: number,
): FeeAdjustmentRow[] => {
  if (feeAdjustments && feeAdjustments.length > 0) {
    return feeAdjustments.map((r) => ({
      type: r.type,
      amount: Number(r.amount) || 0,
    }));
  }
  if (legacyFeeAdjustment) {
    return [{ type: 'Other', amount: legacyFeeAdjustment }];
  }
  return [];
};
